<template>
  <div id="qanda-page" ref="whole_page">
    <ul class="fixed-max-width-650" style="flex-wrap: wrap;">
      <li class="mb-5">
        <vx-card ref="chat_card" class="q-and-a-item__black-gradient vs-con-loading__container">
          <div class="vx-row">
            <div class="vx-col w-full">
              <div class="vx-row">
                <div class="vx-col w-2/5 self-center">
                  <svg xmlns="http://www.w3.org/2000/svg" style="color: white" width="100" height="100" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-youtube"><path d="M22.54 6.42a2.78 2.78 0 0 0-1.94-2C18.88 4 12 4 12 4s-6.88 0-8.6.46a2.78 2.78 0 0 0-1.94 2A29 29 0 0 0 1 11.75a29 29 0 0 0 .46 5.33A2.78 2.78 0 0 0 3.4 19c1.72.46 8.6.46 8.6.46s6.88 0 8.6-.46a2.78 2.78 0 0 0 1.94-2 29 29 0 0 0 .46-5.25 29 29 0 0 0-.46-5.33z"></path><polygon points="9.75 15.02 15.5 11.75 9.75 8.48 9.75 15.02"></polygon></svg>
                </div>
                <div class="vx-col w-3/5 self-center">
                  <p class="uppercase" :class="{'gradient-text_header__40': windowWidth < 570 || isMobile(), 'gradient-text_header': windowWidth >= 570 && !isMobile()}">Media</p>
                </div>
              </div>
            </div>
          </div>
          <div class="vx-row mt-5">
            <div class="vx-col w-full">
              <vx-card id="q-and-a-search-input_container" class="card__no-padding" style="border-radius: 30px !important;background-color: rgb(102, 102, 102);">
                <vx-input-group>
                  <vs-input class="w-full q-and-a-search_input" @keyup.enter="executeSearch" onClick="this.select();" placeholder="Search..." v-model="query" />

                  <template slot="append" class="append-slot-border">
                    <div @click="executeSearch" class="append-text school-primary_gradient input-search_button" style="border-radius: 30px !important;">
                      <span><feather-icon class="pt-1" icon="SearchIcon" svg-classes="stroke-current"></feather-icon></span>
                    </div>
                  </template>
                </vx-input-group>
              </vx-card>
            </div>
          </div>
        </vx-card>
      </li>      
    </ul>
    <ul v-show="mediaContent.length > 0" class="fixed-max-width-650 text-left q-and-a_list" style="flex-wrap: wrap;">
      <li v-for="(_item, index) in mediaContent" :key="index" class="mb-4">
        <vx-card class="glow-effect_dark limit-height_content-height fixed-max-width-650 card__no-padding bg-color">
          <vx-input-group>
            <template slot="prepend">
              <div class="prepend-text glow-effect_dark limit-height_content-height input-group_prepend-slot-bg" style="width: 70px;border-radius: 5px 0 0 5px !important;">
                <span><feather-icon class="pt-1 ml-3" :icon="getIcon(_item)" svg-classes="stroke-current"></feather-icon></span>
              </div>
            </template>

            <vs-button size="large"
              class="w-full glow-effect_primary limit-height_content-height button-text__left-align school-primary_gradient"
              style="border-radius:0 7px 7px 0;"
              @click.stop="contentSelected(_item)"
            >
              <strong>{{ _item.name }}</strong>
              <p class="pt-1"><strong><small>{{ _item.description }}</small></strong></p>
              <div class="vx-row mt-3" v-show="_item.typeInt == 3 && showPlayer">
                <div class="vx-col w-full">
                  <div :id="`podcast-container_${_item.id}`" :ref="`podcastViewer_${_item.id}`" class="w-full vs-con-loading__container">
                    <video :id="`podcastPlayer_${_item.id}`" class="media-video-player card-video" controls />
                  </div>
                </div>
              </div>
            </vs-button>
            <div class="absolute" style="top: 0;right: 0;">
              <vs-button class="download-btn" icon-pack="feather" icon="icon-download" type="flat" radius size="large" color="white" @click.stop.prevent="download(_item)" />
            </div>
          </vx-input-group>
        </vx-card>
      </li>
    </ul>
    <ul v-show="mediaContent.length == 0">
      <li>
        <p style="color:white;font-weight:500;font-size:16px;padding-top:5px">There are no multimedia content available right now...</p>
      </li>
    </ul>
  </div>
</template>

<script>
  import Plyr from 'plyr';
  import 'plyr/dist/plyr.css';  
  export default {
    data() {
      return {
        query: "",
        mediaContent: [],
        showPlayer: false,
        podcastPlayer: null,
        fileExt: "",
        source: [],
        selectedItem: 0,
        windowWidth: window.innerWidth
      }
    },
    components: {
      Plyr
    },
    computed: {
      
    },
    watch: {
      
    },
    methods: {
      download(item) {
        var link = document.createElement("a");
        link.setAttribute("download",true);
        var filename = item.url.substring(item.url.lastIndexOf('/') + 1);
        var urlToDownload = null;
        link.id = "link";

        switch (item.typeInt) {
          case 1:
            var searchMask = "/index.m3u8";
            var regEx = new RegExp(searchMask, "ig");
            var replaceMask = ".mp4";

            urlToDownload = item.url;

            if (!urlToDownload.includes(".mp4")){
              urlToDownload = urlToDownload.replace(regEx, replaceMask);
            }

            filename = urlToDownload.substring(urlToDownload.lastIndexOf('/') + 1);
            
            link.href = urlToDownload;
            break;
          case 2:
            urlToDownload = item.url;
            link.href = urlToDownload;
            break;
          case 3:
            urlToDownload = item.url;
            link.href = urlToDownload;
            break;
        };

        link.download = true;
        link.target = "_blank";
        link.textContent = filename;

        link.click();


        link.remove();
      },
      executeSearch() {
        var self = this;
        self.loadData();
      },
      loadData() {
        var self = this;
        self.showLoadingOnElement("whole_page", 1, "material");

        var onSuccess = response => {
          self.mediaContent = response.data;
        };
        var onFinally = response => {
          self.$vs.loading.close(self.$refs.whole_page.$el);
        };

        self.$ajaxGet(self, `Student/GetMultimediaContent?moduleId=${self.$route.query.module}&query=${self.query}`, onSuccess, onFinally);
      },
      getIcon(item) {
        switch (item.typeInt) {
          case 1:
            return "YoutubeIcon";
          case 2:
            return "FileTextIcon"
          case 3:
            return "MicIcon"
        };
      },
      contentSelected(item) {
        var self = this;
        
        
        if (self.selectedItem != item.id) {
          self.selectedItem = item.id;
          self.showPlayer = false;
          self.destroyPlayer();
          switch (item.typeInt) {
            case 1:
              self.$router.push({ name: 'MultimediaVideoViewer', query: { id: item.id, url: item.url, module: self.$route.query.module, n: self.$route.query.n, orig: "media" } });
              return;
            case 2:
              self.$router.push({ name: 'DocumentViewer', query: { id: item.id, url: item.url, module: self.$route.query.module, n: self.$route.query.n, mentoring: true, orig: "media" } });
              return;
            case 3:
              self.showPlayer = true;
              self.playPodcast(item.id, item.url);
              // return;
          };
        }
      },
      playPodcast(id, podcastUrl) {
        var self = this;

        self.podcastPlayer = new Plyr(`#podcastPlayer_${id}`, {
          autoplay: false
        });
        self.showLoadingOnElement(`podcastViewer_${id}`, 1, "material");

        var counter = 0;
        self.podcastPlayer.on('canplay', event => {
          counter++;
          if(counter == 2){
            self.$vs.loading.close(self.$refs[`podcastViewer_${id}`].$el);
          }
        });

        self.fileExt = podcastUrl.substr(podcastUrl.lastIndexOf(".") + 1);
        self.source = [{ type: "audio/" + self.fileExt, src: podcastUrl }];
        self.podcastPlayer.source = {
          type: 'audio',
          sources: self.source
        };
      },
      destroyPlayer() {
        var self = this;
        if(self.podcastPlayer)
          self.podcastPlayer.destroy();
      },
      showLoadingOnElement(element, scale, type, color) {
        var self = this;
        self.$vs.loading({
          color: color,
          type: type,
          container: self.$refs[element].$el,
          scale: scale
        });
      },
      handleWindowResize(event) {
        this.windowWidth = event.currentTarget.innerWidth;
      },
    },   
    mounted() {
      var self = this;
      self.loadData();

      self.$nextTick(() => {
        window.addEventListener("resize", self.handleWindowResize);
      });
    },
    beforeDestroy() {
      window.removeEventListener("resize", self.handleWindowResize);
    }
  }

</script>

<style lang="scss">
div[id*='podcast-container_'] {
  overflow: visible !important;

  border-style: solid !important;
  border-width: 2px !important;
  border-radius: 30px !important;

  .plyr--audio .plyr__controls {
    background: rgba(250, 250, 250, 0) !important;
    color: white !important;

    .plyr__control:hover {
      background: rgba(var(--vs-fontcolor), 1) !important;
    }
  }
  
  .plyr--full-ui input[type=range] {
    color: rgba(255, 255, 255, 1) !important;
  }
}

.download-btn {
  &.isActive {
    // background: black !important;
  }

  &:hover {
    background: rgba(0,0,0,0.3) !important;
  }

  .vs-button--background {
    background: rgba(0,0,0,0) !important;
    opacity: 0 !important;
  }
}
</style>
